import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery";
import Expand from "@arcgis/core/widgets/Expand";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Sketch from "@arcgis/core/widgets/Sketch";
import Measurement from "@arcgis/core/widgets/Measurement";
import Legend from "@arcgis/core/widgets/Legend";
import LayerList from "@arcgis/core/widgets/LayerList";
import Search from "@arcgis/core/widgets/Search";
import { UserInformationService } from "../../shared/services/user/user-information.service";
import Bookmarks from "@arcgis/core/widgets/Bookmarks";
import { DrawToolRemoveComponent } from "./draw/draw-remove-all/draw-remove-all";
import { DrawBufferToolbarComponent } from "./draw/draw-buffer/draw-buffer-toolbar";
import { DrawBufferCheckboxComponent } from "./draw/draw-buffer/draw-buffer-checkbox";
import { MeasureComponent } from "./measure/measure.component";
import CoordinateConversion from "@arcgis/core/widgets/CoordinateConversion";
import { ExtentComponent } from "./extent/extent.component";
import { LayerListComponent } from "./layer-list/layer-list.component";
import { BookmarkComponent } from "./bookmark/bookmark.component";
import { SearchComponent } from "./search/search.component";
import Home from "@arcgis/core/widgets/Home";
let MapTools = class MapTools {
    userInformationService;
    drawRemoveAll;
    bufferWindow;
    bufferCheckbox;
    measureTool;
    extentTool;
    layerList;
    bookmark;
    search;
    buffEnabled;
    bufferLayer;
    sketchGraphicsLayer;
    mapTools = [];
    expandableWidgets = {};
    constructor(userInformationService, drawRemoveAll, bufferWindow, bufferCheckbox, measureTool, extentTool, layerList, bookmark, search) {
        this.userInformationService = userInformationService;
        this.drawRemoveAll = drawRemoveAll;
        this.bufferWindow = bufferWindow;
        this.bufferCheckbox = bufferCheckbox;
        this.measureTool = measureTool;
        this.extentTool = extentTool;
        this.layerList = layerList;
        this.bookmark = bookmark;
        this.search = search;
    }
    addBasemaps(mapView) {
        const basemapGallery = new BasemapGallery({
            view: mapView,
            source: {
                portal: {
                    url: "https://www.arcgis.com",
                    useVectorBasemaps: false
                }
            }
        });
        this.addToolExpand(mapView, basemapGallery, "basemapGalleryWidget", "top-right", "Select Basemap");
    }
    addDraw(mapView) {
        this.sketchGraphicsLayer = new GraphicsLayer({
            id: "Draw Tool Layer",
            title: "Draw Tool Layer",
            listMode: "hide",
        });
        this.bufferLayer = new GraphicsLayer({
            title: "Buffer Layer",
            listMode: "hide"
        });
        mapView.map.add(this.bufferLayer);
        mapView.map.add(this.sketchGraphicsLayer);
        // TODO: Hide error Accessor#set 'hybrid' is not a valid value for this property, only the following values are valid: 'freehand', 'click'
        const sketch = new Sketch({
            defaultCreateOptions: {
                mode: "hybrid"
            },
            view: mapView,
            layer: this.sketchGraphicsLayer,
            id: "drawTool",
            container: document.createElement("div"),
        });
        this.drawRemoveAll.addRemoveAllButton(mapView, this.sketchGraphicsLayer, this.bufferLayer, sketch);
        this.bufferCheckbox.addBufferCheckbox(mapView);
        this.bufferWindow.addBufferWindow(mapView, sketch);
        this.addToolExpand(mapView, sketch, "drawTool", "top-left", "Draw", "brush-mark");
        sketch.on("create", event => {
            this.bufferWindow.addBuffer(event, this.bufferLayer, this.buffEnabled);
        });
        this.mapTools.push(sketch);
    }
    toggleBuffer(event) {
        this.buffEnabled = event;
        if (!event) {
            this.bufferLayer.removeAll();
        }
    }
    addMeasure(mapView) {
        const Measure = new Measurement({
            view: mapView,
            linearUnit: "meters",
            areaUnit: "square-meters",
            id: "measure"
        });
        const Location = new CoordinateConversion({
            view: mapView,
        });
        this.measureTool.initializeMeasureTool(mapView, Measure, Location);
        const btnMeasure = document.getElementById("measureWidget");
        this.addToolExpand(mapView, btnMeasure, "measureWidget", "top-left", "Measure", "measure-area");
    }
    // public addPrint(mapView: MapView, moduleId: number): void {
    //   const print = this.printTool.initializePrintTool(mapView, moduleId);
    //   this.addToolExpand(mapView, print, "printWidget", "top-left", "Print");
    // }
    addExtent(mapView, isSysAdmin) {
        if (isSysAdmin) {
            const textContainer = this.extentTool.addExtentTool(mapView);
            this.addToolExpand(mapView, textContainer, "textContainerWidget", "top-left", "Get Current Extent", "extent");
        }
    }
    addLegend(mapView) {
        const legend = new Legend({
            view: mapView
        });
        this.addToolExpand(mapView, legend, "legendWidget", "top-right", "Legend");
    }
    addLayerList(mapView) {
        const layerList = new LayerList({
            view: mapView,
            listItemCreatedFunction: this.layerList.layerActions
        });
        this.addToolExpand(mapView, layerList, "layerListWidget", "top-right", "Layers");
        layerList.on("trigger-action", event => {
            this.layerList.layerActionTrigger(event);
        });
    }
    addBookmark(mapView) {
        const bookmarks = new Bookmarks({
            view: mapView,
            editingEnabled: true,
        });
        const bookmarksCollection = this.bookmark.addBookmarks();
        bookmarks.bookmarks = bookmarksCollection;
        this.addToolExpand(mapView, bookmarks, "bookmarksWidget", "top-right", "Bookmark");
    }
    addSearch(mapView) {
        const sources = this.search.getCustomSources();
        const search = new Search({
            id: "searchWidget", view: mapView,
            allPlaceholder: "Search for place or address", sources,
            suggestionsEnabled: true,
            maxSuggestions: 6,
            minSuggestCharacters: 0,
            includeDefaultSources: false,
        });
        search.on("search-complete", (event) => {
            if (event && event.results && event.results.length > 0) {
                this.search.searchMultipleResults(event, mapView);
            }
        });
        mapView.ui.add(search, "top-right");
    }
    addHome(mapView) {
        const homeBtn = new Home({
            view: mapView
        });
        // Add the home button to the top left corner of the view
        mapView.ui.add(homeBtn, "top-right");
    }
    addToolExpand(mapView, tool, name, position, Title, icon) {
        const expand = new Expand({
            expandTooltip: Title,
            view: mapView,
            content: tool,
            expandIcon: icon
        });
        mapView.ui.add(expand, position);
        this.expandableWidgets[name] = expand;
    }
    getMapTool(id) {
        return this.mapTools.find(t => t.id === id);
    }
    expandWidget(name) {
        this.expandableWidgets[name].expand();
    }
    collapseWidget(name) {
        this.expandableWidgets[name].collapse();
    }
    static ctorParameters = () => [
        { type: UserInformationService },
        { type: DrawToolRemoveComponent },
        { type: DrawBufferToolbarComponent },
        { type: DrawBufferCheckboxComponent },
        { type: MeasureComponent },
        { type: ExtentComponent },
        { type: LayerListComponent },
        { type: BookmarkComponent },
        { type: SearchComponent }
    ];
};
MapTools = __decorate([
    Injectable({
        providedIn: "root"
    })
], MapTools);
export { MapTools };
